
<div class="header-toolbar">
  <h1>
    Entités

    <span class="tag" *ngIf="filter.search">
      <span class="text">Recherche: {{ filter.search }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearSearch()"></t-icon>
    </span>

    <span class="tag" *ngIf="filter.hasMovements !== undefined">
      <span class="text">Avec mouvements: {{ filter.hasMovements ? 'Oui' : 'Non' }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearHasMovements()"></t-icon>
    </span>
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'/shares-ledger/entities/new'">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </a>
      <button class="btn" (click)="applyFilter()">
        <t-icon name="search"></t-icon>
        <span class="text">Filtrer</span>
      </button>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th style="width: 20px;"></th>
      <th>Nom</th>
      <th style="width: 100px">Type</th>
      <th style="width: 320px">Créé par</th>
      <th style="width: 110px">Date d'ajout</th>
    </tr>
  </thead>

  <tbody *ngIf="entities && entities.length > 0">
    <tr *ngFor="let entity of entities" (click)="showSLEntity(entity, $event)">
      <td class="icon-labels">
        <t-icon name="seal_check" *ngIf="entity.hasMovements" title="Avec un registre des mouvements"></t-icon>
      </td>
      <td name="Nom">
        {{ entity.name }}
      </td>
      <td name="Type" style="width: 100px">{{ entity.type | slentitytype }}</td>
      <td name="Créée par" style="width: 320px">{{ entity.createdBy.fullname }}</td>
      <td name="Date d'ajout" style="width: 110px">
        {{ entity.createdAt | tzdate:'short' }}
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!entities || entities.length == 0">
    <tr>
      <td class="text-center" colspan="5">
        <ng-container *ngIf="entities && entities.length == 0">
          Aucune entité n'a été trouvée
        </ng-container>
        <ng-container *ngIf="!entities">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="entities">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="entities.length < entitiesCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ entities.length }} / {{ entitiesCount }}
  </div>
</div>